module.exports = __webpack_public_path__ + "static/media/icon-transections.8fd6cf07.svg";